import React from 'react';

import Helmet from 'react-helmet';
import applyBorder from './custom_styles/border';
import { ALIGNMENTS, BORDER_RADII } from 'app/modules/configuration/constants';
import { shiftColorShade, determineFontColor } from 'lib/colorLogic.js';
var colorShiftAmount = 4;
var transitionTime = 0.1;

const CustomStyles = ({ alignment, colors, font, dropshadowEnabled, border, borderRadius, isMinimized, zIndex }) => {
  return (
    <Helmet>
      {applyPrimaryColor(colors)}
      {applySecondaryColor(colors)}
      {applyAccentColor(colors)}
      {applyAlertColor(colors)}
      {applySubmitButtonColor(colors)}

      {applyCustomAlignment(alignment)}
      {applyCustomFont(font)}
      {applyDropshadowEnabled(dropshadowEnabled)}
      {applyBorderRadius(borderRadius)}
      {applyBorder(border)}
      {applyZIndex(isMinimized, zIndex)}
    </Helmet>
  );
};

const applySubmitButtonColor = colors => {
  if ('submitArrow' in colors) {
    return (
      <style type="text/css">
        {`
          #gladlyChat_container .chatSubmitArrow_customColors {
            stroke: ${colors.submitArrow} !important;
          }
       `}
      </style>
    );
  }
};

const applyZIndex = (isMinimized, zIndex) => {
  if (isMinimized) {
    return (
      <style type="text/css">
        {`
            #gladlyChat_container {
              z-index: ${zIndex} !important;
            }
         `}
      </style>
    );
  }
};

const applyPrimaryColor = colors => {
  if ('brandPrimary' in colors) {
    return (
      <style type="text/css">
        {`
          #gladlyChat_container .chatIcon_customFillColors {
            fill: ${determineFontColor(colors.brandPrimary)} !important;
          }

          #gladlyChat_container .minimizedChatButtonSelector, #gladlyChat_container .onboarding_submitButton_selector{
            background: ${colors.brandPrimary} !important;
            border: ${colors.brandPrimary} !important;
            color: ${determineFontColor(colors.brandPrimary)} !important;
          }

          #gladlyChat_container .minimizedChatButtonSelector:hover, #gladlyChat_container .onboarding_submitButton_selector:hover {
            background: ${shiftColorShade(colors.brandPrimary, colorShiftAmount)} !important;
            -webkit-transition: background-color ${transitionTime}s ease !important;
            -moz-transition: background-color ${transitionTime}s ease !important;
            -o-transition: background-color ${transitionTime}s ease !important;
            transition: background-color ${transitionTime}s ease !important;
          }

          #gladlyChat_container .minimizedChatButtonSelector:active, #gladlyChat_container .onboarding_submitButton_selector:active {
            background: ${shiftColorShade(colors.brandPrimary, -colorShiftAmount)} !important;
            webkit-transition: background-color ${transitionTime}s ease !important;
            -moz-transition: background-color ${transitionTime}s ease !important;
            -o-transition: background-color ${transitionTime}s ease !important;
            transition: background-color ${transitionTime}s ease !important;
          }

          #gladlyChat_container .chatSubmitArrow_customColors, #gladlyChat_container .chatIcon_customStrokeColors {
            stroke: ${colors.brandPrimary} !important;
          }

          #gladlyChat_container .minimizedChatButtonSelector:hover .chatIcon_customStrokeColors {
            stroke: ${shiftColorShade(colors.brandPrimary, colorShiftAmount)}!important;
            webkit-transition: stroke ${transitionTime}s ease !important;
            -moz-transition: stroke ${transitionTime}s ease !important;
            -o-transition: stroke ${transitionTime}s ease !important;
            transition: stroke ${transitionTime}s ease !important;
          }

          #gladlyChat_container .minimizedChatButtonSelector:active .chatIcon_customStrokeColors {
            stroke: ${shiftColorShade(colors.brandPrimary, -colorShiftAmount)}!important;
            webkit-transition: stroke ${transitionTime}s ease !important;
            -moz-transition: stroke ${transitionTime}s ease !important;
            -o-transition: stroke ${transitionTime}s ease !important;
            transition: stroke ${transitionTime}s ease !important;
          }


          #gladlyChat_container .message_agent, #gladlyChat_container .typingIndicator {
            background: ${colors.brandPrimary} !important;
            border: 1px solid ${shiftColorShade(colors.brandPrimary, -colorShiftAmount)} !important;
            color: ${determineFontColor(colors.brandPrimary)} !important;
          }

          #gladlyChat_container .chatLink_customAgentColors {
            color: ${determineFontColor(colors.brandPrimary)} !important;
          }

          #gladlyChat_container .typingIndicator_dots {
            background-color: ${determineFontColor(colors.brandPrimary)} !important;
          }
        `}
      </style>
    );
  }
};

const applySecondaryColor = colors => {
  if ('brandSecondary' in colors) {
    return (
      <style type="text/css">
        {`
        #gladlyChat_container .message_customer {
          background: ${colors.brandSecondary} !important;
          border: 1px solid ${shiftColorShade(colors.brandSecondary, -colorShiftAmount)} !important;
          color: ${determineFontColor(colors.brandSecondary)} !important;
        }

        #gladlyChat_container .chatLink_customCustomerColors {
          color: ${determineFontColor(colors.brandSecondary)} !important;
        }
        `}
      </style>
    );
  }
};

const applyAccentColor = colors => {
  if ('brandAccent' in colors) {
    return (
      <style type="text/css">
        {`
        #gladlyChat_container .chatIcon_customFillColors {
          fill: ${determineFontColor(colors.brandAccent)} !important;
        }

        #gladlyChat_container .chatSubmitArrow_customColors, #gladlyChat_container .chatIcon_customStrokeColors {
          stroke: ${colors.brandAccent} !important;
        }

        #gladlyChat_container .minimizedChatButtonSelector, #gladlyChat_container .onboarding_submitButton_selector {
          background: ${colors.brandAccent} !important;
          border: ${colors.brandAccent} !important;
          color: ${determineFontColor(colors.brandAccent)} !important;
        }

        #gladlyChat_container .minimizedChatButtonSelector:hover, #gladlyChat_container .onboarding_submitButton_selector:hover {
          background: ${shiftColorShade(colors.brandAccent, colorShiftAmount)} !important;
        }

        #gladlyChat_container .minimizedChatButtonSelector:active, #gladlyChat_container .onboarding_submitButton_selector:active {
          background: ${shiftColorShade(colors.brandAccent, -colorShiftAmount)} !important;
        }

        #gladlyChat_container .minimizedChatButtonSelector:hover .chatIcon_customStrokeColors {
          stroke: ${shiftColorShade(colors.brandAccent, colorShiftAmount)}!important;
        }

        #gladlyChat_container .minimizedChatButtonSelector:active .chatIcon_customStrokeColors {
          stroke: ${shiftColorShade(colors.brandAccent, -colorShiftAmount)}!important;
        }

        `}
      </style>
    );
  }
};

const applyAlertColor = colors => {
  if ('alert' in colors) {
    return (
      <style type="text/css">
        {`
        #gladlyChat_container .minimizedChatButton_notification {
          background-color: ${colors.alert} !important;
        }
      `}
      </style>
    );
  }
};

const applyCustomAlignment = alignment => {
  let containerAlignment = 'right: 0px !important;';
  if (alignment === ALIGNMENTS.LEFT) {
    containerAlignment = 'left: 0px !important;';
  }
  return (
    <style type="text/css">
      {`#gladlyChat_container {
                ${containerAlignment}
            }`}
    </style>
  );
};

const applyCustomFont = font => {
  if (font) {
    return (
      <style type="text/css">
        {`
      #gladlyChat_container,
      #gladlyChat_container .inputBox_textArea,
      #gladlyChat_container .composition_inputBox,
      #gladlyChat_container .onboarding_submitButton_selector,
      #gladlyChat_container .onboarding_inputBox_name,
      #gladlyChat_container .onboarding_inputBox_email,
      #gladlyChat_container .minimizedChatButtonSelector {
        font-family: ${font} !important;
      }
      `}
      </style>
    );
  }
};

const applyDropshadowEnabled = dropshadowEnabled => {
  if (dropshadowEnabled) {
    return (
      <style type="text/css">
        {`
        #gladlyChat_container .initialChatButton,
        #gladlyChat_container .ongoingChat_selector,
        #gladlyChat_container .onboarding_selector,
        #gladlyChat_container .minimizedChatButtonSelector{
          box-shadow: 0 0 30px 1px rgba(0, 0, 0, 0.2) !important;
        }
        `}
      </style>
    );
  } else {
    return (
      <style type="text/css">
        {`
          #gladlyChat_container .initialChatButton,
          #gladlyChat_container .ongoingChat_selector,
          #gladlyChat_container .onboarding_selector,
          #gladlyChat_container .minimizedChatButtonSelector  {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            -moz-box-shadow: none !important;
          }
        `}
      </style>
    );
  }
};

const applyBorderRadius = borderRadius => {
  if (borderRadius === BORDER_RADII.LARGE) {
    return (
      <style type="text/css">
        {`
        #gladlyChat_container .initialChatButton,
        #gladlyChat_container .onboarding_submitButton_selector,
        #gladlyChat_container .minimizedChatButtonSelector{
          border-radius: 32px !important;
        }

        #gladlyChat_container .minimizedChatButton_notification{
          right: 2px !important;
          top: 0px !important;
        }

        #gladlyChat_container .ongoingChat_selector,
        #gladlyChat_container .onboarding_selector,
        #gladlyChat_container .onboarding,
        #gladlyChat_container .message_agent,
        #gladlyChat_container .message_customer,
        #gladlyChat_container .typingIndicator{
          border-radius: 16px !important;
        }

        #gladlyChat_container .message_agent{
          border-top-left-radius: 0px !important;
          border-bottom-left-radius: 0px !important;
          white-space: pre-wrap !important;
        }

        #gladlyChat_container .message_customer{
          border-top-right-radius: 0px !important;
          border-bottom-right-radius: 0px!important;
          white-space: pre-wrap!important;
        }

        #gladlyChat_container .message_customer:last-child{
          border-bottom-right-radius: 16px !important;
        }

        #gladlyChat_container .message_agent:last-child{
          border-bottom-left-radius: 16px !important;
        }

        #gladlyChat_container .typingIndicator{
          border-top-left-radius: 0px !important;
        }

        #gladlyChat_container .onboarding_inputBox_name,
        #gladlyChat_container .onboarding_inputBox_email{
          border-radius: 4px !important;
        }
        `}
      </style>
    );
  } else if (borderRadius === BORDER_RADII.SMALL) {
    return (
      <style type="text/css">
        {`
          #gladlyChat_container .initialChatButton,
          #gladlyChat_container .onboarding_submitButton_selector,
          #gladlyChat_container .minimizedChatButtonSelector
          {
            border-radius: 4px !important;
          }

          #gladlyChat_container .minimizedChatButton_notification{
            right: -5px !important;
            top: -5px !important;
          }

          #gladlyChat_container .ongoingChat_selector,
          #gladlyChat_container .onboarding,
          #gladlyChat_container .onboarding_selector,
          #gladlyChat_container .message_agent,
          #gladlyChat_container .message_customer,
          #gladlyChat_container .typingIndicator{
            border-radius: 8px !important;
          }

          #gladlyChat_container .message_agent{
            border-top-left-radius: 0px !important;
            border-bottom-left-radius: 0px !important;
            white-space: pre-wrap !important;
          }

          #gladlyChat_container .message_customer{
            border-top-right-radius: 0px !important;
            border-bottom-right-radius: 0px!important;
            white-space: pre-wrap!important;
          }

          #gladlyChat_container .message_customer:last-child{
            border-bottom-right-radius: 8px !important;
          }

          #gladlyChat_container .message_agent:last-child{
            border-bottom-left-radius: 8px !important;
          }

          #gladlyChat_container .typingIndicator{
            border-top-left-radius: 0px !important;
          }

          #gladlyChat_container .onboarding_inputBox_name,
          #gladlyChat_container .onboarding_inputBox_email{
            border-radius: 2px !important;
          }
          `}
      </style>
    );
  } else if (borderRadius === BORDER_RADII.NONE) {
    return (
      <style type="text/css">
        {`
          #gladlyChat_container .initialChatButton,
          #gladlyChat_container .minimizedChatButtonSelector,
          #gladlyChat_container .ongoingChat_selector,
          #gladlyChat_container .onboarding_selector,
          #gladlyChat_container .onboarding,
          #gladlyChat_container .onboarding_inputBox,
          #gladlyChat_container .message_agent,
          #gladlyChat_container .message_customer,
          #gladlyChat_container .typingIndicator,
          #gladlyChat_container .onboarding_inputBox{
            border-radius: 0px !important;
          }

          #gladlyChat_container .minimizedChatButton_notification{
            right: -5px !important;
            top: -5px !important;
          }

          #gladlyChat_container .message_agent{
            white-space: pre-wrap !important;
          }

          #gladlyChat_container .message_customer{
            white-space: pre-wrap !important;
          }
          `}
      </style>
    );
  }
};

export default CustomStyles;
